import notFound from "@/app/not-found";
import {
  getCategories,
  getProductsByCategoryId,
} from "@frontend/lib/actions/actions";
import { getOrgDataFromOrgTitle } from "@frontend/lib/actions/market-graphql-queries";
import { FeaturedCarousel } from "./FeaturedCarousel";

export default async function FeaturedCarouselWrapper({
  params,
  props,
}: {
  params: { clientSlug: string; orgId: number };
  props: {
    scrollId: string;
    isMinimal: boolean;
    primaryActionText: string;
    showIcon?: boolean;
    iconURL?: string;
    categoryDisplayName?: string;
  };
}) {
  const organization = await getOrgDataFromOrgTitle(
    params.clientSlug.toUpperCase(),
  );
  const orgId = organization.findFirstOrganization?.id;

  // Org does not exist under that name
  if (!orgId) {
    return notFound();
  }

  const categories = await getCategories(orgId).then((categories) =>
    categories
      .sort((a, b) => b.popularity - a.popularity)
      .filter((category) => category.name === "Featured"),
  );

  if (!categories?.length) {
    return null;
  }

  const products = await getProductsByCategoryId(
    categories.map((category) => category.id),
  );

  if (!products?.length) {
    return null;
  }

  return (
    <FeaturedCarousel
      products={products.sort((a, b) => b.popularity - a.popularity)}
      clientSlug={params.clientSlug}
      scrollId={props.scrollId}
      primaryActionText={props.primaryActionText}
      isMinimal={props.isMinimal}
      orgId={orgId}
      showIcon={props.showIcon}
      iconURL={props.iconURL}
      categoryDisplayName={props.categoryDisplayName}
    />
  );
}
